import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';


export const SessionModal = ({ modal, toggle }) => {
    return (
        <div>
            <Modal isOpen={ modal } toggle={ toggle } >
                <ModalHeader toggle={ toggle }>Session Expiration</ModalHeader>
                <ModalBody>
                    You Current session has expired!
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={ toggle }>Create New Session</Button>{' '}
                </ModalFooter>
            </Modal>
    </div>
    );
};

SessionModal.propTypes = {
/* 
    modal for session modal component
*/ 
    modal: PropTypes.bool.isRequired,
  }
  
  SessionModal.defaultProps = {
/*
    default value if modal is not given
*/
    modal: 0,
}